import { Link, LinkProps } from 'react-router-dom';
import { TBaseTagContext } from '../types';
import { TTag } from './types';
import UniversalChildren from '../../UniversalTag/UniversalChildren';
import { omit } from 'lodash';
import React from 'react';
import { validate } from '@krugom/validator';
import { TValidationScheme } from '@krugom/validator/dist/types';

const validationScheme: TValidationScheme = {
  type: 'object',
  properties: {
    to: {
      type: 'string',
      required: true,
    },
  },
};

export const CustomLink: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const result = validate(tagProps, validationScheme);

  if (!result.isValid) {
    console.error('Тэг: $Link;', `Путь: ${context.path?.join('.') || 'Не указан'};`, result.errors);
    return <UniversalChildren context={context}>{tagProps.children}</UniversalChildren>;
  }

  return (
    <Link {...(omit(tagProps, ['tag', 'schema']) as unknown as LinkProps)}>
      <UniversalChildren context={context}>{tagProps.children}</UniversalChildren>
    </Link>
  );
});

CustomLink.displayName = 'CustomLink';
